
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1000","height":"1000","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 200L100 0l100 200M50 100h100M0 200q100-200 200 0","fill":"none","stroke":"pink","stroke-width":"2"}}),_c('circle',{attrs:{"cy":"200","r":"2"}}),_c('circle',{attrs:{"cx":"100","r":"2"}}),_c('circle',{attrs:{"cx":"200","cy":"200","r":"2"}}),_c('text',{attrs:{"y":"200","dx":"10"}},[_v('A')]),_c('text',{attrs:{"x":"100","dx":"20","dy":"20"}},[_v('B')]),_c('text',{attrs:{"x":"200","y":"200","dx":"10"}},[_v('C')]),_c('text',{attrs:{"y":"300","transform":"rotate(30 100 500)","rotate":"0,45,90,120","fill":"red"}},[_v('hello')]),_c('text',{attrs:{"y":"400","fill":"red"}},[_v('1 '),_c('tspan',{attrs:{"x":"0","y":"420"}},[_v('22')]),_c('tspan',{attrs:{"x":"0","y":"440"}},[_v('22')])]),_c('a',{attrs:{"xlink:href":"https://www.baidu.com","target":"_blank"}},[_c('text',{attrs:{"y":"480","fill":"#00f"}},[_v('百度')])])])
          )
        }
      }
    